import { GotoLogger, Logger } from '@getgo/goto-logger'

import { attachToLoggerService } from './loggingService'

let rootLogger: Logger | null = null

const getLogger = (): Logger => {
  if (!rootLogger) {
    rootLogger = createRootLogger()
  }

  return rootLogger
}

const createRootLogger = (): Logger => {
  const logger = GotoLogger.createRoot({ mincategory: 'debug' })
  attachToLoggerService(logger)
  return logger
}

export default getLogger
